export default {"src":"/_next/static/media/Senior-badge.3322e37f.svg","height":46,"width":46};